import { AutomatedActionOffer } from '@core/automated-actions-types';
import { Visibility } from '@core/visibility-types';

export enum AutomationActionType {
  SendEmail = 'candidate_send_email',
  AddTags = 'candidate_add_tags',
  AddNote = 'candidate_add_note',
  AddTask = 'candidate_add_task',
  EvaluationRequest = 'candidate_request_evaluation',
  AddFollowers = 'candidate_add_followers',
  AssignTo = 'candidate_assign_to_job',
}

export type AssignToReferences = {
  offers: AutomatedActionOffer[];
  talentPools: AutomatedActionOffer[];
};

export type AutomationAction =
  | SendEmailAction
  | AddTagsAction
  | AddTaskAction
  | AddFollowersAction
  | AddNoteAction
  | RequestEvaluationAction
  | AssignAction;

export type SendEmailAction = {
  type: AutomationActionType.SendEmail;
  data: any; // to fix
};

export type AddTagsAction = {
  type: AutomationActionType.AddTags;
  data: AddTagsActionData;
};

export type AddTaskAction = {
  type: AutomationActionType.AddTask;
  data: AddTaskActionData;
};

export type AddFollowersAction = {
  type: AutomationActionType.AddFollowers;
  data: AddFollowersActionData;
};

export type AddNoteAction = {
  type: AutomationActionType.AddNote;
  data: AddNoteActionData;
};

export type RequestEvaluationAction = {
  type: AutomationActionType.EvaluationRequest;
  data: RequestEvaluationActionData;
};

export type AssignAction = {
  type: AutomationActionType.AssignTo;
  data: AssignActionData;
};

export type AddTagsActionData = {
  tags: string[];
};

export type AddTaskActionData = {
  adminIds: number[];
  dueDateType: 'relative' | 'absolute' | null;
  dueDateUnit: string | null;
  dueDateValue: string | null;
  title: string;
  timezone: string | null;
  adminIdsAddAdminPerformingAction: boolean;
  adminIdsAddHiringManager: boolean;
  adminIdsAddRecruiter: boolean;
};

export type AddFollowersActionData = {
  followerIds: number[];
  adminIdsAddRecruiter: boolean;
  adminIdsAddHiringManager: boolean;
};

export type AddNoteActionData = {
  body: string;
  bodyJson: object | null;
  bodyHtml: string;
  visibility: Visibility;
};

export type RequestEvaluationActionData = {
  interviewTemplateId: number | null;
  adminIds: number[];
  adminIdsAddHiringManager: boolean;
  adminIdsAddRecruiter: boolean;
};

export type AssignActionData = {
  offerIds: number[];
  talentPoolIds: number[];
  references?: AssignToReferences;
};
